import { Connection } from '@solana/web3.js'
import * as anchor from "@project-serum/anchor";
import { Program } from "@project-serum/anchor";
import * as splToken from "@solana/spl-token";
import axios from 'axios';
import { Spldegen } from "../idl/spldegen/spldegen";
import idl from "../idl/spldegen/spldegen.json"
import { SPLDEGEN_ERRORS, TOKENS } from "../constants/constants";
import { setToken } from "../redux/reducers/storageSlice"
export const getTokenBalance = async (token, wallet) => {
  let mint = TOKENS[token]["mint"]
  try {
    let resp = await axios.post(process.env.REACT_APP_RPC_URL,  {
      "jsonrpc": "2.0",
      "id": 1,
      "method": "getTokenAccountsByOwner",
      "params": [
        wallet.publicKey.toBase58(),
        {
          "mint": mint
        },
        {
          "encoding": "jsonParsed"
        }
      ]
    })
    let tokenBal = resp.data.result.value[0].account.data.parsed.info.tokenAmount.uiAmount;
    return tokenBal
  } catch (err) {
    console.log(err)
  }
}

const sleep = (ms) => {
  return new Promise(
    resolve => setTimeout(resolve, ms)
  );
}    
export const getBets = async (multiplier, token) => {
    let search = {}
    if (multiplier) search = {multiplier: multiplier, token: "SOL"}
    if (token) search["token"] = token
    const serverUrl = process.env.REACT_APP_BET_SERVER + "/recentBets"
    const { data } = await axios.post(
        serverUrl,
        search,
        {}
    );  
    // console.log(data)
    return data        
}

export const getBetsByUser = async (wallet, multiplier, amount, token) => {
    let search = {wallet: wallet, token: "SOL"}
    if (multiplier) search["multiplier"] = multiplier
    if (token) search["token"] = token
    if (amount) search["amount"] = amount
    const serverUrl = process.env.REACT_APP_BET_SERVER + "/getBetsByUser"
    const { data } = await axios.post(
        serverUrl,
        search,
        {}
    );  
    // console.log(data)
    return data        
}


export const playTokenBet = async (amount, multiplier, token, wallet, dispatch, setBetAmount, setBetMultiplier, setLoaderMsg, setGameState, setLoaderImage) => {
  try {   
    let decimals = TOKENS[token]["decimals"]
    let splIndex = TOKENS[token]["index"]
    let multiplierDetails = TOKENS[token]["betConstraints"].find((el)=>{
      // console.log(el)
      return el.value == multiplier
    })
    let multiplierIndex = multiplierDetails["index"]
    let amountToBet = amount * decimals
    let amount_to_bet = new anchor.BN(amountToBet)
    let player = wallet.publicKey
    // console.log("Decimals:", decimals, "SPL Index:", splIndex, "Multiplier Index:",multiplierIndex,"Lamports:", amount_to_bet)
    // console.log(wallet)
    // console.log("Actual amount:", amount*To)
      const connection = new Connection(process.env.REACT_APP_RPC_URL, {commitment: "confirmed",confirmTransactionInitialTimeout:120000});
      const program_id = process.env.REACT_APP_SPLDEGEN_PROGRAM_ID
      const programId = new anchor.web3.PublicKey(program_id);
      const provider = new anchor.AnchorProvider(connection, wallet, anchor.AnchorProvider.defaultOptions())  
      anchor.setProvider(provider);
      const program = new anchor.Program(
          idl,
          programId,
          provider,
          new anchor.BorshCoder(idl)
      ) as anchor.Program<Soldegen>;
      let msg = multiplier + "x bet with " + amount + " " + token
      let [globalAccount] = anchor.web3.PublicKey.findProgramAddressSync(
        [Buffer.from("GLOBAL_VAULT")],
        program.programId
      );

      let [splState] = anchor.web3.PublicKey.findProgramAddressSync(
        [Buffer.from("SPL_STATE")],
        program.programId
      );

      let [playeraccount] = anchor.web3.PublicKey.findProgramAddressSync(
        [Buffer.from("PLAYER_ACCOUNT"), player.toBuffer()],
        program.programId
      );

      const feeaccount = new anchor.web3.PublicKey(process.env.REACT_APP_SPLDEGEN_FEE_ACCOUNT)
      const adminKepair = {
        publicKey: new anchor.web3.PublicKey(process.env.REACT_APP_SPLDEGEN_ADMIN_ACCOUNT)
      }

      let isUserAccountExist = null, playerAccountData = null;
      // console.log(TOKENS[token])
      let splMintKey = new anchor.web3.PublicKey(TOKENS[token]["mint"]);

      try {
          isUserAccountExist = await program.account.playerState.getAccountInfo(
            playeraccount
          );
      } catch (err1) {
          console.log(err1)
      }
      // console.log(isUserAccountExist)
      let userTx;
      setLoaderMsg(<div>Confirming Deposit<br/>{msg}</div>)

      let protocol_mint_ata = await withFindOrInitAssociatedTokenAccount(
        provider.connection, 
        splMintKey, 
        globalAccount, 
        player, 
        playeraccount, 
        true
      )

      let fee_mint_ata = await withFindOrInitAssociatedTokenAccount(
        provider.connection, 
        splMintKey, 
        feeaccount, 
        feeaccount, 
        playeraccount, 
        true
      )

      let player_mint_ata = await withFindOrInitAssociatedTokenAccount(
        provider.connection, 
        splMintKey, 
        player, 
        player,
        playeraccount, 
        true
      )    
      // console.log(protocol_mint_ata, fee_mint_ata, player_mint_ata)
      // console.log(splState)
      if (isUserAccountExist == null) {
        // console.log(multiplierIndex, amount_to_bet, splIndex)
        // console.log("HEREYEE")
        userTx = await program.methods.initPlaySpl(multiplierIndex, amount_to_bet, splIndex)
          .accounts({
            globalAccount: globalAccount,
            feeAccount: fee_mint_ata,
            playerAccount: playeraccount,
            allowedSplMint: splState,
            splMint: splMintKey,
            protocolMintAta: protocol_mint_ata,
            playerMintAta: player_mint_ata,
            admin: adminKepair.publicKey,
            payer: player,
            systemProgram: anchor.web3.SystemProgram.programId,
            tokenProgram: splToken.TOKEN_PROGRAM_ID
          })
          .rpc()

        // console.log("txHash :: ", userTx);
      } else {
        // console.log(multiplierIndex, amount_to_bet, splIndex)
          userTx = await program.methods.playSpl(multiplierIndex, amount_to_bet, splIndex)
          .accounts({
            globalAccount: globalAccount,
            feeAccount: fee_mint_ata,
            playerAccount: playeraccount,
            allowedSplMint: splState,
            splMint: splMintKey,
            protocolMintAta: protocol_mint_ata,
            playerMintAta: player_mint_ata,
            admin: adminKepair.publicKey,
            payer: player,
            systemProgram: anchor.web3.SystemProgram.programId,
            tokenProgram: splToken.TOKEN_PROGRAM_ID
          })
          .rpc()

        // console.log("txHash :: ", userTx);
      }
      setLoaderImage("images/trident2.gif")
      setLoaderMsg(<div>Deposit Confirmed<br/>{msg}</div>)
      // const playerTx = await connection.confirmTransaction(userTx);
  // //     // await sleep(3000)
      const serverUrl = process.env.REACT_APP_TOKEN_BET_SERVER + "/placeTokenBet"
      const { data } = await axios.post(
        serverUrl,
        { player: wallet.publicKey.toBase58(), multiplier: multiplier, amount: amount, token: token },
        { }
      );
      data["status"] = "success"
      return data
  } catch (err) {
    console.log(err)
    // console.log(JSON.parse(JSON.stringify(err)))
      if (err["error"]["errorCode"]["number"] == 6004){
          let oldBetLamports = err["logs"][2].split("Bet Amount: ").pop()
          let multiplierIndex =  err["logs"][3].split("Multiplier: ").pop()
          let splIndex = err["logs"][4].split("SPL: ").pop()
          let foundToken = Object.keys(TOKENS).find((key) => TOKENS[key]["index"] == splIndex)
          let oldBetAmount = oldBetLamports / TOKENS[foundToken]["decimals"]
          let oldMultiplierObj= TOKENS[foundToken]["betConstraints"].find((bet) => bet.index = multiplierIndex)
          let oldMultiplierAmount = oldMultiplierObj["value"]
          let msg = "COMPLETING A PREVIOUSLY UNFINISHED " + oldMultiplierAmount + "X BET WITH "+ oldBetAmount + " " + foundToken
          dispatch(setToken(foundToken))
          dispatch(setBetAmount(oldBetAmount))
          dispatch(setBetMultiplier(oldMultiplierAmount))
          setLoaderMsg(msg)
          const serverUrl = process.env.REACT_APP_TOKEN_BET_SERVER + "/placeTokenBet"
          try {
            const { data } = await axios.post(
              serverUrl,
              { player: wallet.publicKey.toBase58(), multiplier: oldMultiplierAmount, amount: oldBetAmount, token: foundToken },
              { }
            );
            data["status"] = "success"
            return data          
          } catch (error) {
            return handleError(error)  
          }
      } else {
          return handleError(err)
      }
  }
}


const handleError = (error) => {
  let data = {status: "error encountered"}
  if ( (error.code == "ERR_BAD_RESPONSE") && (error.hasOwnProperty('response')) && (error["response"].hasOwnProperty('data')) && (error["response"]["data"].hasOwnProperty('code')) ) {
    let errorCode = error['response']['data']['code'];
    // console.log(SPLDEGEN_ERRORS[errorCode]["msg"])
    data["loaderImg"] = SPLDEGEN_ERRORS[errorCode]["loaderImg"]
    data["msg"] = SPLDEGEN_ERRORS[errorCode]["errorMsg"]
    if (errorCode =="6007"){
      data["status"] = "paused game"
      data["subMsgs"] =[ SPLDEGEN_ERRORS[errorCode]["subMsg1"], SPLDEGEN_ERRORS[errorCode]["subMsg2"]] 
    }
    return data;
  }
}

export const withFindOrInitAssociatedTokenAccount = async (
  connection: anchor.web3.Connection,
  mint: anchor.web3.PublicKey,
  owner: anchor.web3.PublicKey,
  payer: anchor.web3.PublicKey,
  signer: anchor.web3.Keypair,
  allowOwnerOffCurve?: boolean
): Promise<anchor.web3.PublicKey> => {
  let transaction = new anchor.web3.Transaction();
  const associatedAddress = await splToken.Token.getAssociatedTokenAddress(
    splToken.ASSOCIATED_TOKEN_PROGRAM_ID,
    splToken.TOKEN_PROGRAM_ID,
    mint,
    owner,
    allowOwnerOffCurve
  );
  // console.log(associatedAddress)
  const account = await connection.getAccountInfo(associatedAddress);
  if (!account) {
    console.log("account not found for", owner.toBase58())
    transaction.add(
      splToken.Token.createAssociatedTokenAccountInstruction(
        splToken.ASSOCIATED_TOKEN_PROGRAM_ID,
        splToken.TOKEN_PROGRAM_ID,
        mint,
        associatedAddress,
        owner,
        payer
      )
    );

    const txHash = await connection.sendTransaction(transaction, [signer])
    // console.log("Create ATA txHash :: ", txHash);
  } else {
    // console.log("account found for", owner.toBase58())
  }
  return associatedAddress;
}